module.exports = __webpack_public_path__ + "img/volumeSmall.1cf9bccd.svg";